import { endOfWeek, startOfWeek } from "date-fns"

const currentWeek = () => {
  return { start: startOfWeek(Date.now(), { weekStartsOn: 1 }), end: endOfWeek(Date.now(), { weekStartsOn: 1 }) }
}

export { currentWeek }